(() => {
  if (document.documentElement.dataset.cartDeliveryRequestReady === 'true') return;

  document.documentElement.dataset.cartDeliveryRequestReady = 'true';

  let delivery_form_values = {};
  let keep_cart_drawer_open_after_discount = false;
  let keep_delivery_request_after_discount = false;

  const get_delivery_parts = (element) => {
    const summary = element.closest('.cart-drawer__summary');
    const drawer = element.closest('cart-drawer-component');

    if (!summary || !drawer) return {};

    return {
      drawer,
      content: drawer.querySelector('.cart-drawer__content'),
      summary,
      request: summary.querySelector('.cart-delivery-request'),
      thank_you: summary.querySelector('[data-delivery-thank-you]'),
      options: summary.querySelector('.cart-delivery-options'),
      form: summary.querySelector('[data-delivery-form]'),
      submit: summary.querySelector('[data-delivery-submit]'),
      error: summary.querySelector('[data-delivery-error]'),
      success: summary.querySelector('[data-delivery-success]'),
    };
  };

  const update_select_placeholder = (field) => {
    if (!field.matches('.cart-delivery-request__select')) return;

    if (field.value) {
      field.removeAttribute('data-placeholder');
    } else {
      field.setAttribute('data-placeholder', 'true');
    }
  };

  const save_delivery_form_values = (parts) => {
    if (!parts.form) return;

    delivery_form_values = {};

    Array.from(parts.form.elements).forEach((field) => {
      if (!field.name) return;

      delivery_form_values[field.name] = field.value;
    });
  };

  const restore_delivery_form_values = (parts) => {
    if (!parts.form) return;

    Object.entries(delivery_form_values).forEach(([name, value]) => {
      const field = parts.form.elements[name];
      if (!field) return;

      field.value = value;
      update_select_placeholder(field);
    });
  };

  const align_delivery_request = (parts) => {
    if (
      !parts.content ||
      !parts.summary ||
      (!parts.drawer.classList.contains('cart-drawer--delivery-request') &&
        !parts.drawer.classList.contains('cart-drawer--delivery-success'))
    ) {
      return;
    }

    parts.summary.style.marginTop = '';
    parts.summary.style.marginBottom = '';

    requestAnimationFrame(() => {
      const available_space = parts.content.clientHeight - parts.summary.scrollHeight;
      const vertical_space = Math.max(Math.floor(available_space / 2), 0);

      parts.summary.style.marginTop = `${vertical_space}px`;
      parts.summary.style.marginBottom = `${vertical_space}px`;
    });
  };

  const restore_delivery_request = (summary) => {
    const parts = get_delivery_parts(summary);

    if (!parts.drawer?.classList.contains('cart-drawer--delivery-request')) return;
    if (!parts.request || !parts.options || !parts.submit) return;

    parts.request.hidden = false;
    parts.submit.hidden = false;
    parts.options.hidden = true;
    restore_delivery_form_values(parts);
    align_delivery_request(parts);
  };

  const remember_cart_drawer_state = (element) => {
    const drawer = element.closest('cart-drawer-component');
    const dialog = drawer?.querySelector('.cart-drawer__dialog');
    const request = drawer?.querySelector('.cart-delivery-request');

    keep_cart_drawer_open_after_discount = Boolean(dialog?.open);
    keep_delivery_request_after_discount = Boolean(
      drawer?.classList.contains('cart-drawer--delivery-request') && request && !request.hidden
    );
  };

  const restore_cart_options = (parts) => {
    parts.drawer.classList.remove('cart-drawer--delivery-request');
    parts.drawer.classList.remove('cart-drawer--delivery-success');

    if (parts.summary) {
      parts.summary.style.marginTop = '';
      parts.summary.style.marginBottom = '';
    }

    if (parts.request) parts.request.hidden = true;
    if (parts.thank_you) parts.thank_you.hidden = true;
    if (parts.submit) parts.submit.hidden = true;
    if (parts.options) parts.options.hidden = false;
  };

  const restore_cart_drawer_after_discount = () => {
    if (!keep_cart_drawer_open_after_discount) return;

    requestAnimationFrame(() => {
      const drawer = document.querySelector('cart-drawer-component');
      const dialog = drawer?.querySelector('.cart-drawer__dialog');

      if (!drawer || !dialog) return;

      if (!dialog.open) {
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      }

      if (keep_delivery_request_after_discount) {
        drawer.classList.add('cart-drawer--delivery-request');
        restore_delivery_request(drawer.querySelector('.cart-drawer__summary'));
      } else {
        restore_cart_options(get_delivery_parts(drawer.querySelector('.cart-drawer__summary')));
      }

      keep_cart_drawer_open_after_discount = false;
      keep_delivery_request_after_discount = false;
    });
  };

  const get_cart_section_ids = () => {
    const section_ids = [];

    document.querySelectorAll('cart-items-component').forEach((component) => {
      const section_id = component.dataset.sectionId;

      if (section_id && !section_ids.includes(section_id)) {
        section_ids.push(section_id);
      }
    });

    return section_ids;
  };

  const refresh_cart_sections = async () => {
    const section_ids = get_cart_section_ids();

    if (section_ids.length === 0) return;

    const sections_url = new URL(window.location.href);
    sections_url.searchParams.set('sections', section_ids.join(','));

    const response = await fetch(sections_url.toString(), {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Unable to refresh the cart after submitting the delivery request.');
    }

    const sections = await response.json();

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: null,
          sourceId: 'cart-delivery-request',
          data: {
            itemCount: 0,
            source: 'cart-delivery-request',
            sections,
          },
        },
      })
    );
  };

  const update_cart_delivery_method = async (method) => {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          delivery_method: method,
        },
      }),
    });

    if (!response.ok) {
      throw new Error('Unable to update delivery method.');
    }
  };

  const show_delivery_request = (button) => {
    const parts = get_delivery_parts(button);

    if (!parts.request || !parts.options || !parts.submit) return;

    parts.drawer.classList.add('cart-drawer--delivery-request');
    parts.drawer.classList.remove('cart-drawer--delivery-success');
    parts.request.hidden = false;
    if (parts.thank_you) parts.thank_you.hidden = true;
    parts.submit.hidden = false;
    parts.options.hidden = true;

    if (parts.error) parts.error.hidden = true;
    if (parts.success) parts.success.hidden = true;

    restore_delivery_form_values(parts);

    const first_input = parts.request.querySelector('input, select');
    if (first_input) first_input.focus();

    align_delivery_request(parts);
  };

  const show_cart_options = async (button) => {
    const parts = get_delivery_parts(button);

    if (!parts.request || !parts.options || !parts.submit) return;

    if (parts.drawer.classList.contains('cart-drawer--delivery-success')) {
      restore_cart_options(parts);

      try {
        await refresh_cart_sections();
      } catch (error) {
        console.error(error);
      }

      return;
    }

    restore_cart_options(parts);
  };

  const show_delivery_success = (parts) => {
    parts.drawer.classList.remove('cart-drawer--delivery-request');
    parts.drawer.classList.add('cart-drawer--delivery-success');

    if (parts.request) parts.request.hidden = true;
    if (parts.thank_you) parts.thank_you.hidden = false;
    if (parts.options) parts.options.hidden = true;
    if (parts.submit) parts.submit.hidden = true;
    if (parts.error) parts.error.hidden = true;
    if (parts.success) parts.success.hidden = true;

    align_delivery_request(parts);
  };

  const is_valid_email = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);

  const get_australian_phone = (phone) => {
    let phone_number = phone.replace(/[^\d+]/g, '');

    if (phone_number.startsWith('+61')) {
      phone_number = `0${phone_number.slice(3)}`;
    } else if (phone_number.startsWith('61')) {
      phone_number = `0${phone_number.slice(2)}`;
    }

    return phone_number;
  };

  const is_valid_australian_phone = (phone) => {
    const phone_number = get_australian_phone(phone);
    const phone_patterns = [/^04\d{8}$/, /^0[2378]\d{8}$/, /^1300\d{6}$/, /^1800\d{6}$/, /^13\d{4}$/];

    return phone_patterns.some((pattern) => pattern.test(phone_number));
  };

  const set_field_error = (field, has_error) => {
    field.classList.toggle('cart-delivery-request__input--error', has_error);
  };

  const set_submit_loading = (button, is_loading) => {
    if (!button) return;

    const continue_label = button.dataset.continueButtonLabel || 'Continue';

    button.disabled = is_loading;
    button.classList.toggle('cart-delivery-request__submit--loading', is_loading);
    button.querySelector('.button-text').textContent = is_loading ? 'Submitting...' : continue_label;
  };

  const get_delivery_message = (form, message_name, fallback) => {
    return form?.dataset?.[message_name] || fallback;
  };

  const get_empty_cart_error_message = (form) => {
    return get_delivery_message(
      form,
      'emptyCartErrorMessage',
      'Your cart is empty. Please refresh and try again.'
    );
  };

  const get_field_value = (form, name) => {
    const field = form.elements[name];

    return field ? field.value.trim() : '';
  };

  const get_payload_phone_number = (phone) => {
    const phone_number = get_australian_phone(phone);

    if (phone_number.startsWith('+61')) return phone_number;
    if (phone_number.startsWith('61')) return `+${phone_number}`;
    if (phone_number.startsWith('0')) return `+61${phone_number.slice(1)}`;

    return phone_number;
  };

  const get_discount_application_payload = (discount_application) => {
    if (!discount_application) return null;

    return {
      type: discount_application.type,
      title: discount_application.title,
      value: discount_application.value,
      value_type: discount_application.value_type,
      total_allocated_amount: discount_application.total_allocated_amount,
    };
  };

  const get_line_discount_application_payload = (discount_application) => {
    if (!discount_application) return null;

    return {
      title: discount_application.title,
      value: discount_application.value,
      value_type: discount_application.value_type,
    };
  };

  const get_cart_item_tags_by_key = () => {
    const tags_by_key = {};

    document.querySelectorAll('.cart-items__table-row[data-key][data-product-tags]').forEach((row) => {
      const item_key = row.dataset.key;

      if (!item_key || tags_by_key[item_key]) return;

      tags_by_key[item_key] = row.dataset.productTags
        .split('|')
        .map((tag) => tag.trim())
        .filter(Boolean);
    });

    return tags_by_key;
  };

  const get_line_item_payload = (cart_item, tags_by_key) => {
    return {
      variant_id: String(cart_item.variant_id),
      quantity: cart_item.quantity,
      key: cart_item.key,
      title: cart_item.title,
      product_title: cart_item.product_title,
      product_type: cart_item.product_type,
      handle: cart_item.handle,
      tags: tags_by_key[cart_item.key] || [],
      variant_title: cart_item.variant_title,
      variant_options: cart_item.variant_options || [],
      options_with_values: cart_item.options_with_values || [],
      original_price: cart_item.original_price,
      price: cart_item.price,
      presentment_price: cart_item.presentment_price,
      discounted_price: cart_item.discounted_price,
      line_price: cart_item.line_price,
      original_line_price: cart_item.original_line_price,
      total_discount: cart_item.total_discount,
      discounts: cart_item.discounts || [],
      final_price: cart_item.final_price,
      final_line_price: cart_item.final_line_price,
      properties: cart_item.properties || {},
      line_level_discount_allocations: (cart_item.line_level_discount_allocations || []).map((allocation) => ({
        amount: allocation.amount,
        discount_application: get_line_discount_application_payload(allocation.discount_application),
      })),
      line_level_total_discount: cart_item.line_level_total_discount || 0,
      has_components: Boolean(cart_item.has_components),
    };
  };

  const get_delivery_request_payload = async (form) => {
    const cart_response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!cart_response.ok) {
      throw new Error('Unable to read cart before submitting delivery request.');
    }

    const cart = await cart_response.json();
    const tags_by_key = get_cart_item_tags_by_key();
    const cart_items = Array.isArray(cart.items) ? cart.items : [];

    if (cart_items.length === 0) {
      throw new Error(get_empty_cart_error_message(form));
    }

    return {
      first_name: get_field_value(form, 'first_name'),
      last_name: get_field_value(form, 'last_name'),
      company_name: get_field_value(form, 'company_name'),
      address: get_field_value(form, 'address'),
      apartment: get_field_value(form, 'address_2'),
      suburb: get_field_value(form, 'suburb'),
      state: get_field_value(form, 'state'),
      postcode: get_field_value(form, 'postcode'),
      phone_number: get_payload_phone_number(get_field_value(form, 'phone')),
      email: get_field_value(form, 'email'),
      postcodes_within_50km_radius: form.getAttribute('data-postcodes-within-50km-radius') || '',
      attributes: cart.attributes || {},
      currency: cart.currency,
      line_items: cart_items.map((cart_item) => get_line_item_payload(cart_item, tags_by_key)),
      total_discount: cart.total_discount,
      cart_level_discount_applications: cart.cart_level_discount_applications.map(get_discount_application_payload),
      discount_codes: cart.discount_codes,
    };
  };

  const submit_delivery_request = async (parts) => {
    const endpoint = parts.form.dataset.customBackendEndpoint;

    if (!endpoint) {
      throw new Error('Custom Backend Endpoint is missing from theme settings.');
    }

    const request_payload = await get_delivery_request_payload(parts.form);
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(request_payload),
    });
    const response_data = await response.json().catch(() => ({}));

    if (!response.ok) {
      if (response_data.message === 'Missing required field: line_items') {
        throw new Error(get_empty_cart_error_message(parts.form));
      }

      throw new Error(
        response_data.message ||
          get_delivery_message(
            parts.form,
            'submitErrorMessage',
            'Delivery request could not be submitted. Please try again.'
          )
      );
    }

    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    });

    if (response_data.redirect_to_invoice && response_data.invoice_url) {
      window.location.assign(response_data.invoice_url);

      return {
        redirecting: true,
      };
    }

    return {
      redirecting: false,
    };
  };

  const validate_delivery_form = (parts) => {
    const required_fields = Array.from(parts.form.querySelectorAll('[required]'));
    let first_invalid_field = null;
    let message = '';

    required_fields.forEach((field) => {
      const is_empty = field.value.trim() === '';
      set_field_error(field, is_empty);

      if (is_empty && !first_invalid_field) {
        first_invalid_field = field;
        message = get_delivery_message(
          parts.form,
          'requiredFieldsMessage',
          'Please complete all required fields.'
        );
      }
    });

    const email = parts.form.querySelector('[name="email"]');
    const postcode = parts.form.querySelector('[name="postcode"]');
    const phone = parts.form.querySelector('[name="phone"]');

    if (!first_invalid_field && !is_valid_email(email.value.trim())) {
      first_invalid_field = email;
      message = get_delivery_message(
        parts.form,
        'invalidEmailMessage',
        'Please enter a valid email address.'
      );
      set_field_error(email, true);
    }

    if (!first_invalid_field && !/^\d{4}$/.test(postcode.value.trim())) {
      first_invalid_field = postcode;
      message = get_delivery_message(
        parts.form,
        'invalidPostcodeMessage',
        'Please enter a valid 4 digit Australian postcode.'
      );
      set_field_error(postcode, true);
    }

    if (!first_invalid_field && !is_valid_australian_phone(phone.value.trim())) {
      first_invalid_field = phone;
      message = 'Please enter a valid Australian phone number.';
      set_field_error(phone, true);
    }

    return {
      first_invalid_field,
      message,
    };
  };

  document.addEventListener('click', (event) => {
    const discount_remove_button = event.target.closest('.cart-discount__pill-remove');
    if (discount_remove_button) {
      remember_cart_drawer_state(discount_remove_button);
      return;
    }

    const open_button = event.target.closest('[data-delivery-open]');
    if (open_button) {
      show_delivery_request(open_button);
      return;
    }

    const back_button = event.target.closest('[data-delivery-back]');
    if (back_button) {
      show_cart_options(back_button);
      return;
    }

    const close_button = event.target.closest('.cart-drawer__close-button');
    if (close_button) {
      const drawer = close_button.closest('cart-drawer-component');
      const back_button_in_drawer = drawer?.querySelector('[data-delivery-back]');
      if (back_button_in_drawer) show_cart_options(back_button_in_drawer);
    }
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('.cart-delivery-request__input')) return;

    save_delivery_form_values(get_delivery_parts(event.target));
    set_field_error(event.target, false);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.cart-delivery-request__input')) return;

    update_select_placeholder(event.target);
    save_delivery_form_values(get_delivery_parts(event.target));
    set_field_error(event.target, false);
  });

  document.addEventListener('submit', async (event) => {
    if (event.target.matches('.cart-discount__form')) {
      remember_cart_drawer_state(event.target);
      return;
    }

    if (!event.target.matches('[data-delivery-form]')) return;

    event.preventDefault();

    const parts = get_delivery_parts(event.target);
    if (!parts.form || !parts.error || !parts.success) return;

    save_delivery_form_values(parts);

    const validation = validate_delivery_form(parts);

    if (validation.first_invalid_field) {
      parts.success.hidden = true;
      parts.error.textContent = validation.message;
      parts.error.hidden = false;
      validation.first_invalid_field.focus();
      align_delivery_request(parts);
      return;
    }

    try {
      parts.error.hidden = true;
      parts.success.hidden = true;
      set_submit_loading(parts.submit, true);
      const submit_result = await submit_delivery_request(parts);

      if (!submit_result.redirecting) {
        show_delivery_success(parts);
      }
    } catch (error) {
      parts.success.hidden = true;
      parts.error.textContent =
        error.message ||
        get_delivery_message(
          parts.form,
          'submitErrorMessage',
          'Delivery request could not be submitted. Please try again.'
        );
      parts.error.hidden = false;
      align_delivery_request(parts);
    } finally {
      set_submit_loading(parts.submit, false);
    }
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.cart-drawer--delivery-request .cart-drawer__summary').forEach((summary) => {
      align_delivery_request(get_delivery_parts(summary));
    });
  });

  const cart_delivery_observer = new MutationObserver(() => {
    restore_cart_drawer_after_discount();

    document.querySelectorAll('.cart-drawer--delivery-request .cart-drawer__summary').forEach((summary) => {
      restore_delivery_request(summary);
    });
  });

  cart_delivery_observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
